import { createApi, fetchBaseQuery } from "@reduxjs/toolkit/query/react";
import { baseQuery } from "@/redux/ExportPage/fetchBaseQuery";

export const ImportConstituentsApi = createApi({
  reducerPath: "ImportConstituentsApi",
  baseQuery,
  tagTypes: ["Constituents"],
  endpoints: (builder) => ({

    getImportConstituentsById: builder.query({
      query: ({id}) => `/import/product/constituents/${id}`,
      transformResponse: (response) => {
        const data = response?.data ?? [];
        // Ensure it's always an array
        const normalized = Array.isArray(data) ? data : [data];

        // Add `id` field from exportEntityId
        return normalized.map((item) => ({
          ...item,
          id: item.importConstituentsId, 
        }));
      },
      providesTags: ["ImportConstituents"],
    }),



    createImportConstituent: builder.mutation({
      query: ({id , ...data}) => ({
        url: `/import/product/constituents/${id}`,
        method: "PUT", 
        body: { importConstituents:data },
        headers: {
          "X-Request-Id":`${Date.now()}`,
        },
      }),
      invalidatesTags: ["ImportConstituents"],
    }),



    updateImportConstituent: builder.mutation({
      query: ({ id ,subId , ...data  }) => ({
        url: `/import/product/constituents/${id}/${subId}`,
        method: "PUT",
        body: { importConstituents:data},
        headers: {
          "X-Request-Id":`${Date.now()}`,
        },
      }),
      invalidatesTags: ["ImportConstituents"],
    }),

    deleteImportConstituent: builder.mutation({
      query: ({ id }) => ({
        url: `/import/product/constituents/${id}`,
        method: "DELETE",
        headers: {
          "X-Request-Id":`${Date.now()}`,
        },
      }),
      invalidatesTags: ["ImportConstituents"],
    }),

  }),
});

export const {
  useLazyGetImportConstituentsByIdQuery,
  useCreateImportConstituentMutation,
  useUpdateImportConstituentMutation,
  useDeleteImportConstituentMutation,
} = ImportConstituentsApi;
